import React from "react";
import "./AboutUs.css";
import Footer from "../components/Footer";
import Tyler from "../assets/tyler.png";
import Ken from "../assets/ken.png";
import Jake from "../assets/jake.png";
import TwitterIcon from "../assets/twitter.png";
import TikTokIcon from "../assets/tiktok.png";
import InstagramIcon from "../assets/instagram.png";
import YouTubeIcon from "../assets/youtube.png";
import LinkedInIcon from "../assets/linkedin.png";

const teamMembers = [
  {
    name: "Tyler Woyshner",
    role: "Founder & Lead Developer",
    hobby: "Tinkering with startups, building tools that teach",
    funFact: "Launched Blockcode from a single sticky note idea",
    img: Tyler,
    linkedin: "https://www.linkedin.com/in/tyler-woyshner/",
    reverse: false,
  },
  {
    name: "Ken Langsdorf",
    role: "Co-Creator & UX Innovator",
    hobby: "Cosplayer, Critter, D&D Lorebuilder, Collector",
    funFact: "Lives in NY but is a NJ Devils fan",
    img: Ken,
    linkedin: "https://www.linkedin.com/in/ken-langsdorf/",
    reverse: true,
  },
  {
    name: "Jake McGuire",
    role: "Co-Creator & Frontend Engineer",
    hobby: "React wizardry and creative problem solving",
    funFact: "Can debug faster than his coffee brews",
    img: Jake,
    linkedin: "https://www.linkedin.com/in/jake-m-mcguire/",
    reverse: false,
  },
];

const AboutUs = () => {
  return (
    <div className="about-container">
      {/* 👋 Hero Section */}
      <div className="about-hero">
        <h1 className="about-title">Meet the Blockcode Team</h1>
        <p className="about-intro">
          We’re a team of passionate builders on a mission to make learning algorithms feel intuitive, visual, and fun.
        </p>
      </div>

      {/* 👨‍💻 Team Cards */}
      <div className="team-grid">
        {teamMembers.map((member, index) => (
          <div key={index} className={`team-card ${member.reverse ? "reverse" : ""}`}>
            <img src={member.img} alt={member.name} className="team-photo" />
            <div className="team-info">
              <h2>{member.name}</h2>
              <h4>{member.role}</h4>
              <p><strong>Hobby:</strong> {member.hobby}</p>
              <p><strong>Fun Fact:</strong> {member.funFact}</p>
              <a
                href={member.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="linkedin-button"
              >
                View LinkedIn
              </a>
            </div>
          </div>
        ))}
      </div>

      {/* 🌐 Social Media */}
      <div className="social-media-section">
        <h2>Follow Us Online</h2>
        <div className="social-icons">
          <a href="https://x.com/BlockcodeLLC" target="_blank" rel="noopener noreferrer" title="Twitter">
            <img src={TwitterIcon} alt="Twitter" />
          </a>
          <a href="https://www.tiktok.com/@blockcode_llc" target="_blank" rel="noopener noreferrer" title="TikTok">
            <img src={TikTokIcon} alt="TikTok" />
          </a>
          <a href="https://www.instagram.com/blockcode_llc/" target="_blank" rel="noopener noreferrer" title="Instagram">
            <img src={InstagramIcon} alt="Instagram" />
          </a>
          <a href="https://www.youtube.com/@Blockcode_LLC" target="_blank" rel="noopener noreferrer" title="YouTube">
            <img src={YouTubeIcon} alt="YouTube" />
          </a>
          <a href="http://linkedin.com/company/blockcode-llc" target="_blank" rel="noopener noreferrer" title="LinkedIn">
            <img src={LinkedInIcon} alt="LinkedIn" />
          </a>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default AboutUs;
